import { styled, Switch as MuiSwitch, switchClasses } from "@mui/material";

// TODO: Move to MUI theme instead?
const Switch = styled(MuiSwitch)(({ theme }) => ({
  width: 32,
  height: 18,
  padding: 0,
  display: "flex",
  [`& .${switchClasses.switchBase}`]: {
    padding: 2,
    [`&.${switchClasses.checked}`]: {
      transform: "translateX(14px)",
      color: theme.palette.common.white,
      [`& + .${switchClasses.track}`]: {
        opacity: 1,
        backgroundColor: theme.palette.primary.main,
      },
    },
  },
  [`& .${switchClasses.thumb}`]: {
    boxShadow: "0 2px 4px 0 rgb(0 35 11 / 20%)",
    width: 14,
    height: 14,
    borderRadius: 9,
  },
  [`& .${switchClasses.track}`]: {
    borderRadius: 9,
    backgroundColor: theme.palette.grey[400],
  },
}));

export default Switch;
